import { render, staticRenderFns } from "./SubmoduleLoader.vue?vue&type=template&id=361bc2bd&scoped=true"
import script from "./SubmoduleLoader.vue?vue&type=script&lang=js"
export * from "./SubmoduleLoader.vue?vue&type=script&lang=js"
import style0 from "./SubmoduleLoader.vue?vue&type=style&index=0&id=361bc2bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361bc2bd",
  null
  
)

export default component.exports